import React, { Component } from 'react';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import moment from 'moment';
import {
	changeCurrentPath,
	fetchMainList,
	setMainListSelections,
	setMainListState,
	resetMainListState,
	resetConsigneeListStateNew,
} from '../../actions';

import Header from '../../common/containers/header';
import Progress from '../../common/containers/progress'
import SpNav from '../../common/containers/sp_nav'
import Footer from '../../common/containers/footer';

import ErrorDialog from '../../common/components/dialog/error-dialog';
import ReloadModal from '../../common/components/dialog/reload-dialog';
import LogoutModal from '../../common/components/dialog/logout-dialog';

import MainButtons from '../../common/components/main-buttons';
import Tables from '../../common/components/table/common-table';


import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelActions from '@material-ui/core/ExpansionPanelActions';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';

import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import Button from '@material-ui/core/Button';



import {DatePicker}from 'material-ui-pickers';
import {fetchCsvDataMain} from "../../actions/index";

const columns = [
	{ name: 'TorikomiDateTime', title: '最新取込日時',width:150 },
	{ name: 'NohinYoteiYMD', title: '納品日' ,width:150},
	{ name: 'NinushiName', title: '荷主名' ,width:250},
	{ name: 'ButsuryuBotenName', title: '物流母店名称' ,width:200},
	{ name: 'NouhinJigyoushaName', title: '納品事業者名称' ,width:200},
	{ name: 'DenpyoMaisu', title: '伝票枚数' ,width:130, align:'right'},
	{ name: 'InsatsuStatusName', title: '印刷ステータス' ,width:150},
];

const numberColumns = ['TorikomiCount','DenpyoMaisu'];


const styles = theme => ({
	datePicker : {
		marginTop : '-7px',
		width:'150px'
	},
	fromTo : {
		padding: '0 15px',
		fontSize: '1.5rem',
		fontFamily: "Roboto, Helvetica, Arial, sans-serif",
	},
	heading: {
		fontSize: theme.typography.pxToRem(15),
		fontFamily:'Noto Sans JP'
	},
	expands : {
		boxShadow:'initial'
	}
});

const DLMaxCount = 5000;

class MainList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            rows : [],
			dateType : this.props.settings.dateType,
			selectedDateFrom:this.props.settings.selectedDateFrom,
			selectedDateTo:this.props.settings.selectedDateTo,
			selections:this.props.settings.selections,
			filters:this.props.settings.filters,
			sorts : this.props.settings.sorts,
			selectionDetailCount:0,
			showDlErrorDialog:false,
        };

        this.nextIsDetail = false;
        this.isOnloadSumup = this.props.settings.isOnloadSumup;

    }
    /** override methods **/
	UNSAFE_componentWillMount(){
    	if(this.isOnloadSumup) this.handleClickSumup();
		this.props.dispatch(resetConsigneeListStateNew());
	}
	componentDidMount() {
		const { dispatch, history } = this.props;
		window.scrollTo(0, 0);
		dispatch(changeCurrentPath({ currentPath: history.location.pathname }));
	}
	componentWillUnmount(){
		const { dispatch} = this.props;

		if(this.nextIsDetail){
			const {dateType,selectedDateFrom,selectedDateTo,selections,filters,sorts} = this.state;
			dispatch(setMainListState({
				dateType,
				selectedDateFrom,
				selectedDateTo,
				selections,
				filters,
				sorts,
				isOnloadSumup : this.isOnloadSumup
			}))
		}
		else{
			dispatch(resetMainListState());
		}
	}


    /** event handlers **/
	handleDateTypeChange = event => {
		this.setState({ dateType: event.target.value });
	};
	handleDateFromChange = date => {
		let selectedDateTo = this.state.selectedDateTo;
		if(selectedDateTo){
			const dateDiff = selectedDateTo.diff(date,'days');
			if(dateDiff < 0) {
				selectedDateTo = new moment(date);
			}
			else if(dateDiff > 14){
				selectedDateTo = new moment(date);
				selectedDateTo.add(14,'days');
			}
		}
		this.setState({
			selectedDateFrom: date,
			selectedDateTo
		});
	};
	handleDateFromInputChange = (e) =>{
		if(!e.target.value) this.setState({ selectedDateFrom: null });
	};
	handleDateToChange = date => {
		let selectedDateFrom = this.state.selectedDateFrom;
		if(selectedDateFrom){
			const dateDiff = date.diff(selectedDateFrom,'days');
			if(dateDiff < 0) {
				selectedDateFrom = new moment(date);
			}
			else if(dateDiff > 14){
				selectedDateFrom = new moment(date);
				selectedDateFrom.add(-14,'days');
			}
		}
		this.setState({
			selectedDateFrom,
			selectedDateTo: date
		});
	};
	handleDateToInputChange = (e) =>{
		if(!e.target.value) this.setState({ selectedDateTo: null });
	};
	handleRowDoubleClick = row => {
		if(row.isDeleted === "1"){
			return
		}
		const {dispatch, history} = this.props;
		const rows = [row];
		this.nextIsDetail = true;
		this.isOnloadSumup = false;
		dispatch(setMainListSelections({selections : rows}));
		history.push('/detail-list');
	};
	handleSelectionChange = selections => {

		let selectionDetailCount = 0;
		selections.forEach((row)=>{
			selectionDetailCount+=isNaN(row.DetailCount) ? 0 : row.DetailCount;
		});
		this.setState({
			selections,
			selectionDetailCount
		});
	};
	handleSortOrderChange = (sorts) =>{
		this.setState({
			sorts
		});
	};
	handleFilterChange = (filters) =>{
		this.setState({
			filters
		});
	};

	handleClickSumup = event => {
		const {dispatch} = this.props;
		const {dateType, selectedDateFrom, selectedDateTo} = this.state;
		this.setState({
			selections:[]
		});
		dispatch(fetchMainList({
			dateType,
			selectedDateFrom : !(selectedDateFrom) ? null : moment(selectedDateFrom).format('YYYY-MM-DD'),
			selectedDateTo : !(selectedDateTo) ? null : moment(selectedDateTo).format('YYYY-MM-DD'),
			SessionID : this.props.auth.SessionID
		}));
	};

	handleClickDetail = event => {
		const {history, dispatch} = this.props;
		const {dateType, selectedDateFrom, selectedDateTo,selections} = this.state;

		this.nextIsDetail = true;
		this.isOnloadSumup = false;
		dispatch(setMainListSelections({
			selections
		,	dateType
		,	selectedDateFrom : !(selectedDateFrom) ? null : moment(selectedDateFrom).format('YYYY-MM-DD')
		,	selectedDateTo : !(selectedDateTo) ? null : moment(selectedDateTo).format('YYYY-MM-DD')
		}));
		history.push('/detail-list');
	};
	handleClickDL = event => {

		if(this.state.selectionDetailCount>DLMaxCount){
			this.setState({
				showDlErrorDialog:true
			});
			return;
		}

		const {dispatch} = this.props;
		const HeaderIDs = this.state.selections.map(selection=>{
			return selection["id"];
		});
		dispatch(fetchCsvDataMain({
			HeaderIDs : HeaderIDs,
			process_divide : 0,
			SessionID : this.props.auth.SessionID
		}));
	};
	handleClickUpload = event => {
		this.nextIsDetail = true;
		this.isOnloadSumup = false;
		this.props.history.push('/upload/1');
	};

	handleCloseDlError = () =>{
		this.setState({
			showDlErrorDialog:false
		});
	};

	render() {
		const { classes, settings } = this.props;
		const {
			dateType,selectedDateFrom,selectedDateTo,selections,filters,sorts,
			selectionDetailCount,showDlErrorDialog
		} = this.state;

		const rows = settings.data;
		const disabled = !(selections.length);

		const mainButtons = [
			{type:'NEXT',func:this.handleClickDetail,text:"明細",disabled:disabled},
			{type:'DL',func:this.handleClickDL,disabled:disabled},
			{type:'UPLOAD',func:this.handleClickUpload,hasMargin:true},

		];

		const limitText = <span>対象データが大きいため、期間や荷主などでデータを絞り込んで下さい<br/>
			<br/>
			現在の選択件数 : {selectionDetailCount}<br/>
			※同時DL可能上限 : {DLMaxCount}件(明細数)</span>;
		return (
			<div id="main_container">
				{settings.isFetching &&
				<Progress/>
				}
				<SpNav history={this.props.history}/>
				<Header history={this.props.history}/>
				<article>
					<section className="title_area">
						<h2>伝票印刷<span>一覧</span></h2>
					</section>
					<ExpansionPanel defaultExpanded className={classNames("with_button condition_area",classes.expands)}>
						<ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} className={classes.summary}>
							<Typography className={classes.heading}>抽出条件</Typography>
						</ExpansionPanelSummary>
						<ExpansionPanelDetails>
							<FormGroup row>
								<RadioGroup
									aria-label="gender"
									name="gender2"
									value={dateType}
									onChange={this.handleDateTypeChange}
									row
								>
									<FormControlLabel
										value="0"
										control={<Radio />}
										label="出荷日"

									/>
									<FormControlLabel
										value="1"
										control={<Radio />}
										label="納品日"
									/>
									<FormControlLabel
										value="2"
										control={<Radio />}
										label="伝票日付"

									/>
									<FormControlLabel
										value="3"
										control={<Radio />}
										label="取込日"
									/>
								</RadioGroup>
									<DatePicker
										keyboard
										label="開始"
										minDateMessage={"7年前までの日付を入力"}
										maxDateMessage={"10日後までの日付を入力"}
										minDate={new moment().add(-7, 'years')}
										maxDate={new moment().add(10, 'days')}
										value={selectedDateFrom}
										onChange={this.handleDateFromChange}
										onInputChange={this.handleDateFromInputChange}
										format="YYYY/MM/DD"
										className={classes.datePicker}
										invalidDateMessage="日付が正しくありません"
										cancelLabel={"キャンセル"}
									/>
									<div className={classes.fromTo}>-</div>
									<DatePicker
										keyboard
										label="終了"
										minDateMessage={"7年前までの日付を入力"}
										maxDateMessage={"10日後までの日付を入力"}
										minDate={new moment().add(-7, 'years')}
										maxDate={new moment().add(10, 'days')}
										value={selectedDateTo}
										onChange={this.handleDateToChange}
										onInputChange={this.handleDateToInputChange}
										className={classes.datePicker}
										format="YYYY/MM/DD"
										invalidDateMessage="日付が正しくありません"
										cancelLabel={"キャンセル"}
									/>

							</FormGroup>
						</ExpansionPanelDetails>
						<Divider />
						<ExpansionPanelActions>
							<Button variant="contained" color="primary" size="large" onClick={this.handleClickSumup}>
								集計
							</Button>
						</ExpansionPanelActions>
					</ExpansionPanel>
					<section className="with_button">
						<Tables
							dataSource={rows}
							columns={columns}
							selections={selections}
							filters={filters}
							numberColumns={numberColumns}
							doubleClickFunc={this.handleRowDoubleClick}
							getSelections={this.handleSelectionChange}
							getSortOrders={this.handleSortOrderChange}
							getFilters={this.handleFilterChange}
							defaultSorts={sorts}
						/>
					</section>
				</article>
				<MainButtons buttons={mainButtons}/>
				<Footer/>
				<ErrorDialog
					open={showDlErrorDialog}
					title={'利用制限'}
					text={limitText}
					afterCloseFunc={this.handleCloseDlError}
				/>
				<ErrorDialog
					open={this.props.settings.isProcessError}
				/>
				<ReloadModal />
				<LogoutModal />
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		navigation : state.navigation,
		auth: state.auth,
		settings : state.mainListSettings,
		detailSettings : state.detailListSettings
	};
}
export default compose(
	withStyles(styles),
	connect(mapStateToProps)
)(MainList);



// WEBPACK FOOTER //
// ./src/routes/main-list/index.js